import * as React from "react";
function SvgFacebookReactionHaha(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <circle cx={24} cy={24} r={24} fill="#fddb74" />
      <path
        d="M9 24a15 15 0 0030 0zm1.25-9.34l3.93 1.47-3.92 1.39a1.09 1.09 0 00.74 2.06l6-2.17.15-.07a1.36 1.36 0 000-2.4l-.15-.06-6-2.27a1.1 1.1 0 10-.8 2.05h.05zm20.63 2.69l.12.06 6.07 2.16a1.09 1.09 0 10.73-2.06l-3.92-1.39 3.93-1.47a1.09 1.09 0 10-.76-2l-6 2.23-.14.06a1.36 1.36 0 000 2.41z"
        fill="#282c39"
      />
      <path
        d="M24 29a44.43 44.43 0 00-13.35 1.88 15 15 0 0026.69 0A44.43 44.43 0 0024 29z"
        fill="#ea556a"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgFacebookReactionHaha);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
